export const mockServicesListResponse = {
  rescode: 1,
  message: 'Services fetched successfully',
  data: [
    {
      id: 1, clinic_id: 1, name: 'Speech Therapy',
      description: 'Speech and language therapy for communication, articulation, fluency and swallowing disorders',
      price: 1200.00, duration_minutes: 45, color: '#7A6EFE', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 1, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 2, clinic_id: 1, name: 'Occupational Therapy',
      description: 'Improving fine motor skills, sensory processing, daily living and self-care abilities',
      price: 1000.00, duration_minutes: 60, color: '#F59E0B', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 2, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 3, clinic_id: 1, name: 'Physiotherapy',
      description: 'Physical rehabilitation, posture correction, gross motor development and exercise therapy',
      price: 800.00, duration_minutes: 45, color: '#10B981', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 3, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 4, clinic_id: 1, name: 'Special Education',
      description: 'Academic readiness, cognitive skill building, adapted learning for developmental delays',
      price: 900.00, duration_minutes: 60, color: '#6366F1', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 4, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 5, clinic_id: 1, name: 'ABA / Autism Therapy',
      description: 'Applied Behavior Analysis for autism spectrum — behavior modification, social skills and compliance training',
      price: 1500.00, duration_minutes: 90, color: '#EF4444', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 5, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 6, clinic_id: 1, name: 'Feeding Therapy',
      description: 'Oral motor exercises, food texture introduction, mealtime behavior management',
      price: 1100.00, duration_minutes: 45, color: '#EC4899', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 6, created_at: '2025-02-01', updated_at: '2026-03-15',
    },
    {
      id: 7, clinic_id: 1, name: 'Parent Counseling',
      description: 'Guidance sessions for parents on home programs, behavior management and therapy carryover',
      price: 700.00, duration_minutes: 30, color: '#8B5CF6', category: 'Consultation', session_mode: 'Individual',
      is_active: 1, sort_order: 7, created_at: '2025-02-01', updated_at: '2026-03-15',
    },
    {
      id: 8, clinic_id: 1, name: 'Initial Evaluation',
      description: 'Comprehensive assessment with standardized tools, parent interview and goal setting',
      price: 2000.00, duration_minutes: 90, color: '#0EA5E9', category: 'Assessment', session_mode: 'Individual',
      is_active: 1, sort_order: 8, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 9, clinic_id: 1, name: 'Re-Evaluation',
      description: 'Periodic progress assessment, goal review and therapy plan modification',
      price: 1500.00, duration_minutes: 60, color: '#14B8A6', category: 'Assessment', session_mode: 'Individual',
      is_active: 1, sort_order: 9, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 10, clinic_id: 1, name: 'Sensory Integration Therapy',
      description: 'Sensory diet, vestibular and proprioceptive activities for sensory processing disorders',
      price: 1200.00, duration_minutes: 60, color: '#F97316', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 10, created_at: '2025-03-01', updated_at: '2026-03-15',
    },
    {
      id: 11, clinic_id: 1, name: 'Group Social Skills',
      description: 'Peer interaction, turn-taking, sharing and communication in group settings',
      price: 600.00, duration_minutes: 60, color: '#22C55E', category: 'Group Session', session_mode: 'Group',
      is_active: 1, sort_order: 11, created_at: '2025-03-01', updated_at: '2026-03-15',
    },
    {
      id: 12, clinic_id: 1, name: 'Art & Craft Therapy',
      description: 'Creative expression through art, fine motor skill development, attention and focus training',
      price: 500.00, duration_minutes: 45, color: '#A855F7', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 12, created_at: '2025-04-01', updated_at: '2026-03-15',
    },
    {
      id: 13, clinic_id: 1, name: 'Play Therapy',
      description: 'Child-led play for emotional expression, social development and anxiety reduction',
      price: 800.00, duration_minutes: 45, color: '#FB923C', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 13, created_at: '2025-04-01', updated_at: '2026-03-15',
    },
    {
      id: 14, clinic_id: 1, name: 'Home Visit Therapy',
      description: 'Therapist visits at patient home for therapy in natural environment',
      price: 2500.00, duration_minutes: 90, color: '#64748B', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 14, created_at: '2025-05-01', updated_at: '2026-03-15',
    },
    {
      id: 15, clinic_id: 1, name: 'Online Consultation',
      description: 'Video consultation for follow-ups, parent training and remote therapy guidance',
      price: 600.00, duration_minutes: 30, color: '#06B6D4', category: 'Consultation', session_mode: 'Online',
      is_active: 1, sort_order: 15, created_at: '2025-06-01', updated_at: '2026-03-15',
    },
    {
      id: 16, clinic_id: 1, name: 'Music Therapy',
      description: 'Rhythm-based activities for language stimulation, attention and emotional regulation',
      price: 700.00, duration_minutes: 45, color: '#E11D48', category: 'Therapy', session_mode: 'Individual',
      is_active: 1, sort_order: 16, created_at: '2025-07-01', updated_at: '2026-03-15',
    },
    {
      id: 17, clinic_id: 1, name: '3 Day Package',
      description: '3 sessions per week therapy package — ideal for moderate intervention',
      price: 12000.00, duration_minutes: 45, color: '#7C3AED', category: 'Package', session_mode: 'Individual',
      is_active: 1, sort_order: 17, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
    {
      id: 18, clinic_id: 1, name: '5 Day Intensive Package',
      description: '5 sessions per week — intensive daily therapy for ABA, autism and early intervention',
      price: 18000.00, duration_minutes: 60, color: '#DC2626', category: 'Package', session_mode: 'Individual',
      is_active: 1, sort_order: 18, created_at: '2025-01-01', updated_at: '2026-03-15',
    },
  ],
};

export const mockServicesCatalogResponse = {
  rescode: 1,
  message: 'Catalog fetched',
  data: {
    clinic_type: 'child_development',
    services: [
      { name: 'Speech Therapy', description: 'Communication and language therapy', price: 1200, duration_minutes: 45, color: '#7A6EFE', category: 'Therapy' },
      { name: 'Occupational Therapy', description: 'Motor skills and daily living', price: 1000, duration_minutes: 60, color: '#F59E0B', category: 'Therapy' },
      { name: 'Physiotherapy', description: 'Physical rehabilitation', price: 800, duration_minutes: 45, color: '#10B981', category: 'Therapy' },
      { name: 'Special Education', description: 'Academic and cognitive skills', price: 900, duration_minutes: 60, color: '#6366F1', category: 'Therapy' },
      { name: 'ABA Therapy', description: 'Applied Behavior Analysis', price: 1500, duration_minutes: 90, color: '#EF4444', category: 'Therapy' },
    ],
  },
};
